export type ActionButtonSize = "default" | "large";

export type ActionButtonColor = "foreground" | "primary";

export enum ActionButtonVariant {
  foregroundSm = "foregroundSm",
  foregroundLg = "foregroundLg",
  PrimarySm = "primarySm",
  PrimaryLg = "primaryLg",
}

export const actionButtonSizeVariants: Record<ActionButtonSize, string> = {
  default: "rounded-lg font-medium",
  large:
    "h-12 w-full rounded-xl text-base font-semibold shadow-lg transition-colors",
};

export const actionButtonColorVariants: Record<ActionButtonColor, string> = {
  foreground:
    "bg-surface-inverted text-primary-foreground hover:bg-surface-inverted/90",
  primary: "bg-primary text-primary-foreground hover:bg-primary/90",
};

export const actionButtonVariants: Record<
  ActionButtonVariant,
  { size: ActionButtonSize; color: ActionButtonColor }
> = {
  [ActionButtonVariant.foregroundSm]: { size: "default", color: "foreground" },
  [ActionButtonVariant.foregroundLg]: { size: "large", color: "foreground" },
  [ActionButtonVariant.PrimarySm]: { size: "default", color: "primary" },
  [ActionButtonVariant.PrimaryLg]: { size: "large", color: "primary" },
};
